import dndScheduleGroupItemLottie from "Components/Tutorial/DndScheduleGroupItem.json";
import dragAndDropLottie from "Components/Tutorial/DragAndDrop.json";
import resizeLottie from "Components/Tutorial/Resize.json";
import sortScheduleGroupsLottie from "Components/Tutorial/SortScheduleGroups.json";

import { LocalStorageKey } from "Helpers/LocalStorageHelper";
import { TranslationKey } from "translations";
import { TutorialType } from "../types/TutorialType";

export type TutorialTypeRecord = Record<
	TutorialType,
	{ message: TranslationKey; lottie: object; localStorageKey: LocalStorageKey }
>;

export const TUTORIAL_TYPE_RECORD: TutorialTypeRecord = {
	resize: {
		message: "Tutorial_Message_Resize",
		lottie: resizeLottie,
		localStorageKey: LocalStorageKey.IS_RESIZE_TUTORIAL_COMPLETED,
	},
	dragAndDrop: {
		message: "Tutorial_Message_DragAndDrop",
		lottie: dragAndDropLottie,
		localStorageKey: LocalStorageKey.IS_DND_TUTORIAL_COMPLETED,
	},
	dragAndDropScheduleGroupItem: {
		message: "Tutorial_Message_DndScheduleGroupItem",
		lottie: dndScheduleGroupItemLottie,
		localStorageKey:
			LocalStorageKey.IS_DND_SCHEDULE_GROUP_ITEM_TUTORIAL_COMPLETED,
	},
	sortScheduleGroups: {
		message: "Tutorial_Message_SortScheduleGroups",
		lottie: sortScheduleGroupsLottie,
		localStorageKey: LocalStorageKey.IS_SORT_SCHEDULE_GROUPS_TUTORIAL_COMPLETED,
	},
};
